function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ApolloLink } from "@apollo/client";
import { noop } from "@sail/utils";
import determineUnknownErrorType from "../fetchUtils/determineUnknownErrorType";
import DataNetworkError from "../graphql/DataNetworkError";
import { reportRuntimeError } from "../telemetry/internalReporting";
class ApolloLinkExecutor {
    execute(query, variables, context, subscriber) {
        const contextWithFetch = _object_spread_props(_object_spread({}, context), {
            fetch: this.fetchFunction
        });
        try {
            const subscription = ApolloLink.execute(this.link, {
                query,
                variables,
                context: contextWithFetch
            }).subscribe({
                next: function apolloLinkExecutorNext(result) {
                    const { data, errors } = result;
                    if (errors) {
                        subscriber.next({
                            data: data || null,
                            errors: {
                                graphQlErrors: errors,
                                clientErrors: [],
                                networkErrors: []
                            }
                        });
                    } else {
                        subscriber.next({
                            data: data || null,
                            errors: null
                        });
                    }
                },
                // @apollo/client Obsevable types the argument as any, it's important for us to explicitly cast it to unknown.
                error: function apolloLinkExecutorError(error) {
                    if (error instanceof DataNetworkError || // DataNetworkError are created by both v1 and v2 terminating links.
                    // But given that we aim for @sail/data to be generic, we use the logic inside `determineUnknownErrorType`
                    // as a best attempt to determine if the error is a network error.
                    determineUnknownErrorType(error) === 'network') {
                        const networkError = new DataNetworkError(error instanceof Error ? error.message : String(error), -1, null);
                        subscriber.next({
                            data: null,
                            errors: {
                                graphQlErrors: [],
                                clientErrors: [],
                                networkErrors: [
                                    networkError
                                ]
                            }
                        });
                    } else {
                        const typeSafeError = error instanceof Error ? error : new Error(String(error));
                        subscriber.next({
                            data: null,
                            errors: {
                                graphQlErrors: [],
                                clientErrors: [
                                    typeSafeError
                                ],
                                networkErrors: []
                            }
                        });
                    }
                },
                complete: function apolloLinkExecutorComplete() {
                    subscriber.complete();
                }
            });
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        } catch (error) {
            reportRuntimeError(context.observabilityFns, error);
            subscriber.next({
                data: null,
                errors: {
                    graphQlErrors: [],
                    clientErrors: [
                        new Error('Error in ApolloLinkExecutor')
                    ],
                    networkErrors: []
                }
            });
            return {
                unsubscribe: noop
            };
        }
    }
    constructor(link, fetchFunction){
        _define_property(this, "link", void 0);
        _define_property(this, "fetchFunction", void 0);
        this.link = link;
        this.fetchFunction = fetchFunction;
    }
}
export { ApolloLinkExecutor as default };

//# sourceMappingURL=ApolloLinkExecutor.js.map